import type { ZuoraPaymentMethod } from '@kimuno/api-sdk';
import React from 'react';

import { UserPaymentMethodType } from '../../types/User';
import type {
	ZuoraPaymentPageClientSideErrorHandler,
	ZuoraPaymentPageResponse,
} from '../../types/ZuoraPayments';
import usePaymentSetup from '../../utils/usePaymentSetup';
import PaymentInvoiceContent from './PaymentInvoiceContent';
import PaymentPaypalContent from './PaymentPaypalContent';
import PaymentZouraContent from './PaymentZouraContent';

interface PaymentContentProps {
	selectedMethod: string;
	onResponseHandler: (paymentMethod: ZuoraPaymentMethod, response: ZuoraPaymentPageResponse) => void;
	onClientSideErrorHandler?: ZuoraPaymentPageClientSideErrorHandler;
	zuoraHostedPagesSource: string;
}

const PaymentContent = ({
	selectedMethod,
	onResponseHandler,
	onClientSideErrorHandler,
	zuoraHostedPagesSource,
}: PaymentContentProps) => {
	const { paypalToken, hasCreditCardErrors } = usePaymentSetup({
		selectedMethod,
		onResponseHandler,
		onClientSideErrorHandler,
		zuoraHostedPagesSource,
	});

	switch (selectedMethod) {
		case UserPaymentMethodType.SEPA:
		case UserPaymentMethodType.CREDIT_CARD:
			return <PaymentZouraContent method={selectedMethod} hasCreditCardErrors={hasCreditCardErrors} />;
		case UserPaymentMethodType.PAYPAL:
			return <PaymentPaypalContent paypalToken={paypalToken} onResponseHandler={onResponseHandler} />;
		case UserPaymentMethodType.INVOICE:
			return <PaymentInvoiceContent />;
		default:
			return null;
	}
};

export default PaymentContent;
